import React, { useState, useEffect } from 'react'
import { Grid, Typography } from '@material-ui/core'
import ImpactFilters from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/ImpactFilters'

function AcmgFilterModal({ value = [], onChange, onClose }) {
  const [localValue, setLocalValue] = useState(value)

  // Update local state when prop changes
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  // Update parent state whenever localValue changes
  useEffect(() => {
    console.log('ACMG filter value changed:', localValue)
    onChange(localValue)
  }, [localValue, onChange])

  console.log('AcmgFilterModal received value:', value, 'localValue:', localValue)

  const handleChange = (newValue) => {
    console.log('ACMG filter changed locally:', newValue)
    setLocalValue(newValue)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          ACMG Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Select ACMG (American College of Medical Genetics and Genomics) classifications to filter variants.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ImpactFilters impactEvent={localValue} setImpactEvent={handleChange} filterType="acmg" />
      </Grid>
    </Grid>
  )
}

export default AcmgFilterModal
